import { makeAutoObservable } from 'mobx'
import ApisauceDataStore from 'src/packages/fetchx/ApisauceDataStore'
import { apiSauceInstance } from 'src/services/api'
import { HistoricoProgramacaoMotorista } from '../types/historico-programacoes'

class HistoricoIntegracaoStore {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  modalHistorico = false

  openModalHistorico() {
    this.modalHistorico = true
  }

  closeModalHistorico() {
    this.modalHistorico = false
  }

  programacaoId: string = ''
  setProgramacaoId(programacaoId: string) {
    this.programacaoId = programacaoId
  }

  get historicoProgramacoes() {
    return new ApisauceDataStore<any>(apiSauceInstance, {
      path: `/programacoes/${this.programacaoId}t/history-integration`
    })
  }
}

const historicoIntegracaoStore = new HistoricoIntegracaoStore()

export default historicoIntegracaoStore
